import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ProductTagGridComponent } from 'src/app/modules/settings/product-tag-grid/product-tag-grid.component';

@Component({
  selector: 'app-toggle-cell-renderer',
  templateUrl: './toggle-cell-renderer.component.html',
  styleUrls: ['./toggle-cell-renderer.component.scss']
})
export class ToggleCellRendererComponent implements OnInit,OnDestroy {
  params: any;
  private destroy$ = new Subject<void>();
  
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params.data;
  }

  open() {
    this.dialog.open(ProductTagGridComponent, {
      width: "720px",
      data: {
        title: "Product"
      }
    })
      .afterClosed()
      .pipe(filter((res) => res === "save"))
      .subscribe({
        next: () => {
          // this.getSeasons();
        },
      });
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
